import React, { useEffect, useState } from 'react';
import { DeleteOutlined, SwitcherOutlined, UploadOutlined } from '@ant-design/icons';
import { Button, Divider, Form, InputNumber, Upload } from 'antd';
import { Carousel } from 'react-responsive-carousel';
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";



//ONLY ADMIN
import { API_BASE_URL, ASSET_BASE_URL } from '../../../../configs/AppConfig';
import SortableTable from '../../../../components/SortableTable';
import {loadI18n} from "../../../../locales";

loadI18n()

export default {
    Renderer: (props) => {
        const data = props.data

        const [loaded, setLoaded] = useState(false)
        useEffect(() => {
            setLoaded(true)
        }, [])

        if (!loaded || !data.items) {
            return null
        }

        return (
            <div style={{width: "100%", height: "inherit"}}>
                <Carousel
                    autoPlay
                    interval={data.interval || 3000}
                    showThumbs={false}
                    statusFormatter={(currentItem, total) => t`${currentItem} sur ${total}`}
                >
                    {data.items.map(item => {
                        return (
                            <div>
                                <img src={item.image} style={{
                                    maxHeight: data.maxImageHeight ? data.maxImageHeight : "inherit",
                                    objectFit: "contain"
                                }}/>
                            </div>
                        )
                    })}
                </Carousel>
            </div>
        )

    },
    id: 'carousel-image',
    title: t`Carrousel`,
    description: t`Ajouter un Carrousel d'images`,
    icon: <SwitcherOutlined/>,
    version: 1,
    controls: {
        type: 'custom',
        Component: Controls
    }
}

function Controls(props) {

    const {data, onChange} = props

    const [show, setShow] = useState(true)
    const refreshForm = () => {
        setShow(false)
        setTimeout(() => setShow(true), 100)
    }
    useEffect(() => {
        refreshForm()
    }, [props.lang, props.nodeId, props.device])

    if (!show) {
        return null
    }

    if (!Array.isArray(data.items)) {
        onChange({items: []})
        return null
    }

    return (
        <div>
            <Upload.Dragger
                style={{width: "100%"}}
                type={"select"}
                maxCount={1}
                multiple={false}
                accept="image/*"
                showUploadList={false}
                headers={{authorization: localStorage.getItem("AUTH_TOKEN")}}
                action={API_BASE_URL + "/upload/image?autoValide=1"}
                onChange={({file}) => {
                    if (file.response && file.status === "done") {
                        const url = ASSET_BASE_URL + "/" + file.response

                        let items = [...data.items]
                        items.push({image: url})
                        onChange({items: items})
                    }
                }}
            >
                <p className="ant-upload-drag-icon">
                    <UploadOutlined/>
                </p>
                <p className="ant-upload-text"><Trans>Cliquez ou déposez votre image</Trans></p>
            </Upload.Dragger>

            <Divider><Trans>Images</Trans></Divider>

            <SortableTable
                columns={[
                    {
                        title: t`Image`,
                        dataIndex: 'image',
                        align: "center",
                        render: (col, row) => {
                            return <a target="_blank"><img src={col} style={{maxHeight: 150}}/></a>
                        }
                    },
                    {
                        title: t`Supprimer`,
                        action: true,
                        align: "center",
                        render: (col, row, index) => {
                            return (
                                <Button danger icon={<DeleteOutlined/>} onClick={() => {
                                    let items = [...data.items]
                                    items.splice(index, 1)
                                    props.onChange({items: items})
                                }}/>
                            )
                        },
                    },
                ]}
                dataSource={data.items.map(i => {
                    return {
                        id: i.image,
                        image: i.image
                    }
                })}
                onSortChange={(newData) => onChange({items: newData.map(i => ({image: i.image}))})}
            />

            <Divider><Trans>Options</Trans></Divider>

            <Form.Item label={t`Interval de défilement (secondes)`}>
                <InputNumber decimalSeparator={','} min={1} value={data.interval ? data.interval / 1000 : 3}
                             onChange={(v) => onChange({interval: v * 1000})}/>
            </Form.Item>

            <Form.Item label={t`Taille maximale des images`}>
                <InputNumber decimalSeparator={','} value={data.maxImageHeight}
                             onChange={(v) => onChange({maxImageHeight: v})}/>
            </Form.Item>

        </div>
    )
}
